import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useRef,
} from "react";

import api from "../helpers/api.js";

import axios from "axios";

import { useNavigate } from "react-router-dom";

import Config, { token } from "../config.js";

const AuthContext = createContext({ signed: false });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  window.navigate = navigate;

  useEffect(() => {
    if (loading) {
      loadStorageData();
    }
  }, [loading]);

  useEffect(() => {
    window.signed = !!user;
  }, [user]);

  async function loadStorageData() {
    try {
      let localInfo = await localStorage.getItem("@user");

      axios.defaults.baseURL = Config.apiEndpoint;

      if (!localInfo) {
        setLoading(false);
        return;
      }

      localInfo = JSON.parse(localInfo);

      const token = await localStorage.getItem("token");

      axios.defaults.headers.common = {
        Authorization: `Bearer ${token}`,
      };
      axios.defaults.headers.withCredentials = true;

      setTimeout(() => {
        setLoading(false);
      }, 1000);

      setUser(localInfo);
    } catch (e) {
      console.log(e);
    }
  }

  async function login(email, password) {
    try {
      const loginResult = await axios.get(Config.apiEndpoint + "/auth/login", {
        params: { email, password },
      });

      if (loginResult.data.success) {
        Config.apiToken = loginResult.data.token;
        axios.defaults.baseURL = Config.apiEndpoint;
        axios.defaults.headers.common = {
          Authorization: `Bearer ${loginResult.data.token}`,
        };

        await localStorage.setItem(
          "@user",
          JSON.stringify(loginResult.data.user)
        );
        await localStorage.setItem("token", loginResult.data.token);

        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function signOut() {
    if (loading || !window.signed) return;
    window.navigate("/");
    localStorage.clear();
    window.location.reload();
  }

  window.logout = signOut;

  async function handleCreateAccount(values) {
    try {
      const loginResult = await axios.post(
        Config.apiEndpoint + "/auth/signin",
        values
      );

      if (loginResult.data.success) {
        await login(values.email, values.password);
        window.location.href = "communities";
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
    }

    return false;
  }

  return (
    <AuthContext.Provider
      value={{
        signed: !!user,
        user,
        signOut,
        login,
        loading,
        handleCreateAccount,
      }}
    >
      {loading ? <></> : children}
    </AuthContext.Provider>
  );
};

export default AuthContext;

export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider.");
  }

  return context;
}
